import dma from './dma';
import sma from './sma';
import ema from './ema';
import ma from './ma';
import wma from './wma';
export { dma, sma, ema, ma, wma };